export default __webpack_public_path__ + "static/media/noa-39.b9a242b4.jpg";